/**
 * Combined Listings support for R1 custom theme
 * Handles product switching when a combined listing option is selected
 */
(function () {
  'use strict';

  // On page load: if URL has ?variant= param, ensure the correct product is loaded
  // The Combined Listings app handles this via its own web component injection,
  // but we need to listen for its custom events and update the URL accordingly.

  document.addEventListener('DOMContentLoaded', function () {
    // Listen for the Combined Listings variant change event
    document.addEventListener('combined-listing:variant:change', function (event) {
      const { productUrl, variantId } = event.detail;
      if (productUrl) {
        // Navigate to the child product URL with the selected variant
        const url = variantId
          ? productUrl + '?variant=' + variantId
          : productUrl;
        window.history.replaceState({}, '', url);
        // Reload to update product form, images, price, etc.
        window.location.href = url;
      }
    });

    // Also handle the standard Shopify variant change event for URL sync
    document.addEventListener('variant:change', function (event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    });
  });
})();
